import { colors } from '@mui/material';
import palette from '@gobo/gobo.react/lib/styles/theme/palette';

const PAPER_COLOR = '#1c3a3c';
const BACKGROUND_COLOR = '#002528';

const commonSemanticColors = {
  success: {
    dark: '#22946e',
    main: '#47d5a6',
    light: '#9ae8ce',
  },
  error: {
    dark: '#9c2121',
    main: '#d94a4a',
    light: '#eb9e9e',
  },
  warning: {
    dark: '#a87a2a',
    main: '#d7ac61',
    light: '#ecd7b2',
  },
  info: {
    dark: '#21498a',
    main: '#4077d1',
    light: '#92b2e5',
  },
};

export default {
  background: {
    paper: PAPER_COLOR,
    default: BACKGROUND_COLOR,
  },

  DataGrid: {
    bg: PAPER_COLOR,
  },
  TableCell: {
    border: palette.divider,
  },
  ...commonSemanticColors,
  chart: {
    'light-green': commonSemanticColors.success.light,
    green: commonSemanticColors.success.main,
    'dark-green': commonSemanticColors.success.dark,

    'light-red': commonSemanticColors.error.light,
    red: commonSemanticColors.error.main,
    'dark-red': commonSemanticColors.error.dark,

    'light-yellow': commonSemanticColors.warning.light,
    yellow: commonSemanticColors.warning.main,
    'dark-yellow': commonSemanticColors.warning.dark,

    'light-blue': commonSemanticColors.info.light,
    blue: commonSemanticColors.info.main,
    'dark-blue': commonSemanticColors.info.dark,

    'light-lime': colors.lime[200],
    lime: colors.lime[500],
    'dark-lime': colors.lime[700],
    'light-orange': colors.orange[200],
    orange: colors.orange[500],
    'dark-orange': colors.orange[700],
    'light-teal': colors.teal[100],
    teal: colors.teal[400],
    'dark-teal': colors.teal[700],
    'light-purple': colors.purple[100],
    purple: colors.purple[200],
    'dark-purple': colors.purple[400],
    white: '#fff',
  },
};
